/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeeLine
 */
export interface FeeLine {
    /**
     * 
     * @type {string}
     * @memberof FeeLine
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof FeeLine
     */
    amount?: number;
    /**
     * Whether HST applies to this line alone. Set per-checkbox from the checkbox metadata `hst` flag. Absent => the line inherits the document-level fee_hst, which is how every pre-existing document and template behaves.
     * @type {boolean}
     * @memberof FeeLine
     */
    taxable?: boolean;
}

/**
 * Check if a given object implements the FeeLine interface.
 */
export function instanceOfFeeLine(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeeLineFromJSON(json: any): FeeLine {
    return FeeLineFromJSONTyped(json, false);
}

export function FeeLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
    };
}

export function FeeLineToJSON(value?: FeeLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'taxable': value.taxable,
    };
}

